<template>
    <div class="moduleAppAddEdit">
         <div class="top">
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
          <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="content">
            <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="模块Logo" prop="logoUrl">
                        <uploader ref="coverUploader" pathPrefix="moduleApp" openDelete :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']" showResult="image" showMode="button" v-model="logoUrl" :multiple="false"></uploader>
                    </el-form-item>
                    <el-form-item label="模块名称" prop="title">
                        <el-input v-model="formData.title" :maxlength="10" placeholder="请输入模块名称"></el-input>
                    </el-form-item>
                    <el-form-item label="模块编码" prop="moduleCode">
                        <el-input v-if="!isEdit" v-model="formData.moduleCode" :maxlength="10" placeholder="请输入模块编码"></el-input>
                        <span v-else>{{formData.moduleCode}}</span>                        
                    </el-form-item>
                    <el-form-item label="发布范围限制" class="is-required"> 
                         <el-radio-group v-model="formData.scopeLimit">
                            <el-radio :label="1">默认发布范围</el-radio>
                            <el-radio :label="2">自主选择发布范围</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item  label="范围" class="is-required">
                         <el-checkbox v-model.trim="formData.scopeSch" :true-label="1" :false-label="2">全校</el-checkbox>
                         <el-checkbox v-model.trim="formData.scopeTh" :true-label="1" :false-label="2">老师</el-checkbox>
                         <el-checkbox v-model.trim="formData.scopeSt" :true-label="1" :false-label="2">学生</el-checkbox>
                         <!-- <el-checkbox v-model.trim="formData.scopePh" :true-label="1" :false-label="2">家长</el-checkbox>   -->
                    </el-form-item>
                    <el-form-item label="模块功能" class="is-required">
                        <el-checkbox v-model.trim="formData.isTitle" disabled :true-label="1" :false-label="2">标题</el-checkbox>
                        <el-checkbox v-model.trim="formData.isCover" disabled :true-label="1" :false-label="2">封面</el-checkbox>
                        <el-checkbox v-model.trim="formData.isContent" disabled :true-label="1" :false-label="2">内容</el-checkbox>
                        <el-checkbox v-if="formData.scopeLimit==2" v-model.trim="formData.isScope"  disabled :true-label="1" :false-label="2">发布范围</el-checkbox>
                        <el-checkbox v-model.trim="formData.isAdress"  :true-label="1" :false-label="2">地点</el-checkbox>
                        <el-checkbox v-model.trim="formData.isFile"  :true-label="1" :false-label="2">附件材料</el-checkbox>
                        <el-checkbox v-model.trim="formData.isReadCount"  :true-label="1" :false-label="2">阅读量</el-checkbox>
                        <el-checkbox v-model.trim="formData.isTime"  :true-label="1" :false-label="2">时间</el-checkbox>
                        <el-checkbox v-model.trim="formData.isReply"  :true-label="1" :false-label="2">回复</el-checkbox>
                    </el-form-item>
                    <el-form-item label="回复内容" prop="moduleType" v-if="formData.isReply==1" class="is-required">
                        <el-checkbox v-model.trim="formData.isReplyText" :true-label="1" :false-label="2">文本</el-checkbox>
                        <el-checkbox v-model.trim="formData.isReplyFile" :true-label="1" :false-label="2">附件</el-checkbox>
                        

                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';
    import Uploader from "@/components/Uploader/WebUploader";
    import {getMsgInit,updateMsgInit,addMsgInit} from '@/api/releaseModule';

    export default {
        name: "releaseModuleadd",
        components: {BackTool, Uploader},
        data() {
            const validateCode = (rule, value, callback) => {
                value = `${value}`.trim();
                if (value === '') {
                    callback(new Error('应用编码不能为空'));
                } else if(!/^\d+$/.test(value)) {
                    callback(new Error('请输入数字'));
                } else {
                    callback();
                }
            };
            const validateLogo = (rule, value, callback) => {
                if (this.logoUrl.length  === 0) {
                    callback(new Error('请上传logo'));
                } else {
                    callback();
                }
            };
            return {
                isEdit: !!this.$route.query.moduleCode,
                moduleCode: this.$route.query.moduleCode,
                formData: {
                    title:'',//	标题	string
                    logoUr:'',//l	logo	string
                    moduleCode:'',//	模块名称	number
                    scopeLimit:1,//	发布范围限制 1 默认 2 自主选择	number	
                    scopePh:2,//	发布家长 1有 2无	number	
                    scopeSch:2,//	发布全校 1有 2无	number	
                    scopeSt:2,//	发布学生 1有 2无	number	
                    scopeTh:2,//	发布老师 1有 2无	number
                    isTitle:1,//	标题 1 有 2无	number
                    isCover:1,//	封面 1 有 2无	number                    	
                    isContent:1,//	内容 1有 2无	number	
                    isAdress:2,//	地点 1 有 2无	number
                    isFile:2,//	附件材料 1 有 2无	number	
                    isReadCount:2,//	阅读量 1有 2无	number
                    isScope:1,//	发布范围 1 有 2无	number	
                    isTime:2,//	时间 1 有 2无	number	 
                    isReply:2,//	回复 1有 2无	number	
                    isReplyFile:2,//	回复附件 1有 2无	number	
                    isReplyText:2,//	回复文本 1 有 2无	number                        	
                },
                rules: {
                    logoUrl: [
                        {required: true, validator: validateLogo}
                    ],
                    title: [
                        { required: true, message: '请输入模块名称', trigger: 'blur' },
                    ],
                    moduleCode: [
                        { required: true, validator: validateCode },
                    ],
                },
                logoUrl: []

            }
        },
        created() {
            if(this.isEdit) {
                getMsgInit(this.moduleCode)
                    .then(data => {
                        this.formData = data.data.data;
                        this.logoUrl = [{
                            fileUrl: data.data.data.logoUrl
                        }]
                    })
            }
        },
        methods: {
            onsave() {
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        if (this.formData.scopePh == 2&&this.formData.scopeSch == 2&&this.formData.scopeSt == 2&&this.formData.scopeTh == 2) {
                            this.$message({
                            type: "warning",
                            message: "请选择发布范围！"
                            });
                            return;
                        } 
                         if (this.formData.isReply == 1&&this.formData.isReplyFile == 2&&this.formData.isReplyText == 2) {
                            this.$message({
                            type: "warning",
                            message: "请选择回复内容！"
                            });
                            return;
                        } 
                        this.formData.logoUrl=this.logoUrl[0].fileUrl
                        const args = this.formData
                        new Promise(resolve => {
                            if(this.isEdit) {
                                updateMsgInit(args).then(resolve)
                            } else {
                                addMsgInit(args).then(resolve)
                            }
                        })
                            .then(() => {
                                this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
                                window.setTimeout(() => {
                                    this.$router.back();
                                }, 500);
                            })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
 .moduleAppAddEdit{
     padding:12px;
       .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
 }
</style>



// WEBPACK FOOTER //
// src/views/releaseModule/releaseModuleadd.vue